import { formatSignedPctNumber } from "../../lens-stats/formatters";
import { getInsightsDiffPct } from "../math";
import { LensGranularity } from "../models";

export const formatSubscribersDiffValue = (
    currentValue: number,
    prevValue: number,
    selectedTimeRange: LensGranularity,
): string => {
    if (selectedTimeRange === LensGranularity.Lifetime) {
        return "";
    }

    const value = getInsightsDiffPct(currentValue, prevValue);

    return formatSignedPctNumber(value);
};
